import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Table,
	Statistic,
	Row,
	Col,
	Button,
	notification,
	Select,
	DatePicker,
	InputNumber,
	Form,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { useContext } from "react";
import { getAggregateCogsCost } from "../utils/CogCost";

const { Text } = Typography;
const { RangePicker } = DatePicker;

const columns3 = [
	{
		title: "Avg. Profit $/CY",
		dataIndex: "plant",
		key: "plant",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Total",
		dataIndex: "total",
		key: "total",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Jan",
		dataIndex: "Jan",
		key: "Jan",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Feb",
		dataIndex: "Feb",
		key: "Feb",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Mar",
		dataIndex: "Mar",
		key: "Mar",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Apr",
		dataIndex: "Apr",
		key: "Apr",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "May",
		dataIndex: "May",
		key: "May",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Jun",
		dataIndex: "Jun",
		key: "Jun",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Jul",
		dataIndex: "Jul",
		key: "Jul",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Aug",
		dataIndex: "Aug",
		key: "Aug",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Sep",
		dataIndex: "Sep",
		key: "Sep",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Oct",
		dataIndex: "Oct",
		key: "Oct",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Nov",
		dataIndex: "Nov",
		key: "Nov",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
	{
		title: "Dec",
		dataIndex: "Dec",
		key: "Dec",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
					prefix={"$"}
				/>
			);
		},
	},
];

const summaryParent3 = (pageData) => {
	let total = 0;
	let jan = 0;
	let feb = 0;
	let mar = 0;
	let apr = 0;
	let may = 0;
	let jun = 0;
	let jul = 0;
	let aug = 0;
	let sep = 0;
	let oct = 0;
	let nov = 0;
	let dec = 0;

	const length = pageData.length;

	pageData.forEach((item) => {
		total += item.total;
		jan += item.Jan;
		feb += item.Feb;
		mar += item.Mar;
		apr += item.Apr;
		may += item.May;
		jun += item.Jun;
		jul += item.Jul;
		aug += item.Aug;
		sep += item.Sep;
		oct += item.Oct;
		nov += item.Nov;
		dec += item.Dec;
	});

	total = total / length;
	jan = jan / length;
	feb = feb / length;
	mar = mar / length;
	apr = apr / length;
	may = may / length;
	jun = jun / length;
	jul = jul / length;
	aug = aug / length;
	sep = sep / length;
	oct = oct / length;
	nov = nov / length;
	dec = dec / length;

	return (
		<>
			<Table.Summary.Row>
				<Table.Summary.Cell>
					<Text style={{ fontSize: 14 }} strong>
						{"Total Sold"}
					</Text>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={total}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={jan}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={feb}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={mar}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={apr}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={may}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={jun}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={jul}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={aug}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={sep}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={oct}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={nov}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={dec}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				</Table.Summary.Cell>
			</Table.Summary.Row>
		</>
	);
};

const columns4 = [
	{
		title: "CY Sold",
		dataIndex: "plant",
		key: "plant",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Total",
		dataIndex: "total",
		key: "total",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Jan",
		dataIndex: "Jan",
		key: "Jan",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Feb",
		dataIndex: "Feb",
		key: "Feb",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Mar",
		dataIndex: "Mar",
		key: "Mar",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Apr",
		dataIndex: "Apr",
		key: "Apr",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "May",
		dataIndex: "May",
		key: "May",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Jun",
		dataIndex: "Jun",
		key: "Jun",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Jul",
		dataIndex: "Jul",
		key: "Jul",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Aug",
		dataIndex: "Aug",
		key: "Aug",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Sep",
		dataIndex: "Sep",
		key: "Sep",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Oct",
		dataIndex: "Oct",
		key: "Oct",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Nov",
		dataIndex: "Nov",
		key: "Nov",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
	{
		title: "Dec",
		dataIndex: "Dec",
		key: "Dec",
		render: (value) => {
			return (
				<Statistic
					title=""
					value={value}
					precision={2}
					valueStyle={{ fontSize: 14 }}
				/>
			);
		},
	},
];

const summaryParent4 = (pageData) => {
	let total = 0;
	let jan = 0;
	let feb = 0;
	let mar = 0;
	let apr = 0;
	let may = 0;
	let jun = 0;
	let jul = 0;
	let aug = 0;
	let sep = 0;
	let oct = 0;
	let nov = 0;
	let dec = 0;

	pageData.forEach((item) => {
		total += item.total;
		jan += item.Jan;
		feb += item.Feb;
		mar += item.Mar;
		apr += item.Apr;
		may += item.May;
		jun += item.Jun;
		jul += item.Jul;
		aug += item.Aug;
		sep += item.Sep;
		oct += item.Oct;
		nov += item.Nov;
		dec += item.Dec;
	});

	return (
		<>
			<Table.Summary.Row>
				<Table.Summary.Cell>
					<Text style={{ fontSize: 14 }} strong>
						{"Total Sold"}
					</Text>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={total}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={jan}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={feb}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={mar}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={apr}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={may}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={jun}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={jul}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={aug}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={sep}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={oct}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={nov}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
				<Table.Summary.Cell>
					<Statistic
						title=""
						value={dec}
						style={{ fontWeight: "bold" }}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				</Table.Summary.Cell>
			</Table.Summary.Row>
		</>
	);
};

const ProfitabilityReport = () => {
	const [loading, setLoading] = useState(false);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [list, setList] = useState([]);
	const [listCSV, setListCSV] = useState([]);
	const [optionsPlant, setOptionsPlant] = useState([]);
	const [plant, setPlant] = useState("All");
	const [plantName, setPlantName] = useState("All");
	const [apiNotification, contextHolder] = notification.useNotification();
	const [loadingTable, setLoadingTable] = useState(false);
	const [dataProfit, setDataProfit] = useState([]);
	const [loadingTable3, setLoadingTable3] = useState(false);
	const [dataYards, setDataYards] = useState([]);
	const [loadingTable4, setLoadingTable4] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "psi",
			key: "psi",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total $",
			dataIndex: "totalUnitPrice",
			key: "totalUnitPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Sold Price",
			dataIndex: "totalAverage",
			key: "totalAverage",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		plantName !== "All" && {
			title: "QB INVOICED",
			dataIndex: "qbInvoicedAvg",
			key: "qbInvoicedAvg",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		plantName !== "All" && {
			title: "Cogs",
			dataIndex: "cogsAvg",
			key: "cogsAvg",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		plantName !== "All" && {
			title: "QB Price",
			dataIndex: "qbPriceAvg",
			key: "qbPriceAvg",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		plantName !== "All" && {
			title: "Gross Profit",
			dataIndex: "grossProfitAvg",
			key: "grossProfitAvg",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
	].filter(Boolean);

	const EditableContext = React.createContext(null);

	const EditableRow = ({ index, ...props }) => {
		const [form] = Form.useForm();

		return (
			<Form form={form} component={false}>
				<EditableContext.Provider value={form}>
					<tr {...props} />
				</EditableContext.Provider>
			</Form>
		);
	};

	const EditableCell = ({
		editable,
		children,
		dataIndex,
		record,
		handleSave,
		...restProps
	}) => {
		const [editing, setEditing] = useState(false);
		const inputRef = useRef(null);
		const form = useContext(EditableContext);

		useEffect(() => {
			if (editing) {
				inputRef.current?.focus();
			}
		}, [editing]);

		const toggleEdit = () => {
			setEditing(true);
			form.setFieldsValue({
				[dataIndex]: record[dataIndex],
			});
		};

		const save = async () => {
			try {
				const values = await form.validateFields();

				setEditing(false);

				handleSave(
					{
						...record,
						...values,
					},
					dataIndex,
				);
			} catch {}
		};

		const cancel = () => {
			form.setFieldsValue({
				[dataIndex]: record[dataIndex],
			});

			setEditing(false);
		};

		let childNode = children;

		if (editable) {
			childNode = editing ? (
				<Form.Item style={{ margin: 0 }} name={dataIndex}>
					<InputNumber
						ref={inputRef}
						controls={false}
						min={0}
						onPressEnter={save}
						onBlur={cancel}
					/>
				</Form.Item>
			) : (
				<div
					style={{
						cursor: "pointer",
						minHeight: 24,
						minWidth: 60,
					}}
					onClick={toggleEdit}
				>
					${record[dataIndex] ?? 0}
				</div>
			);
		}

		return <td {...restProps}>{childNode}</td>;
	};

	const columns2 = [
		{
			title: "Job ID",
			dataIndex: "jobId",
			key: "jobId",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		plant !== "All" && {
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Mix Design",
			dataIndex: "psi",
			key: "psi",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total $",
			dataIndex: "totalUnitPrice",
			key: "totalUnitPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Sold Price",
			dataIndex: "totalAverage",
			key: "totalAverage",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "QB INVOICED",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionCY",
					key: "missionCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoCY",
					key: "sanbenitoCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleCY",
					key: "brownsvilleCY",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
			].filter(Boolean),
		},

		{
			title: "Clients",
			dataIndex: "client",
			key: "client",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "COGS",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionCogs",
					key: "missionCogs",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoCogs",
					key: "sanbenitoCogs",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleCogs",
					key: "brownsvilleCogs",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		{
			title: "QB PRICE",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionSales",
					key: "missionSales",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoSales",
					key: "sanbenitoSales",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleSales",
					key: "brownsvilleSales",
					render: (value) => {
						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						);
					},
				},
			].filter(Boolean),
		},
		{
			title: "GROSS PROFIT",
			children: [
				(plantName === "All" || plantName === "Mission") && {
					title: "Mission",
					dataIndex: "missionGross",
					key: "missionGross",
					render: (value) => {
						if (value < 0) {
							return <Text>-</Text>;
						}

						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								prefix={"$"}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "San Benito") && {
					title: "San Benito",
					dataIndex: "sanbenitoGross",
					key: "sanbenitoGross",
					render: (value) => {
						if (value < 0) {
							return <Text>-</Text>;
						}

						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								prefix={"$"}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
				(plantName === "All" || plantName === "Brownsville") && {
					title: "Brownsville",
					dataIndex: "brownsvilleGross",
					key: "brownsvilleGross",
					render: (value) => {
						if (value < 0) {
							return <Text>-</Text>;
						}

						return (
							<Statistic
								title=""
								value={value}
								precision={2}
								prefix={"$"}
								valueStyle={{ fontSize: 14 }}
							/>
						);
					},
				},
			].filter(Boolean),
		},
	].filter(Boolean);

	const summaryParent = (pageData) => {
		let totalYardsTotal = 0;
		let totalUnitPriceTotal = 0;

		pageData.forEach((item) => {
			totalYardsTotal += item.totalYards;
			totalUnitPriceTotal += item.totalUnitPrice;
		});

		return (
			<>
				<Table.Summary.Row>
					<Table.Summary.Cell colSpan={2} />
					<Table.Summary.Cell>
						<Text style={{ fontSize: 14 }} strong>
							{"Total"}
						</Text>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalYardsTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
					</Table.Summary.Cell>
					<Table.Summary.Cell>
						<Statistic
							title=""
							value={totalUnitPriceTotal}
							style={{ fontWeight: "bold" }}
							precision={2}
							valueStyle={{ fontSize: 14 }}
							prefix={"$"}
						/>
					</Table.Summary.Cell>
				</Table.Summary.Row>
			</>
		);
	};

	const expandedRowRender = (row) => {
		const summaryChild = (pageData) => {
			let totalYardsTotal = 0;
			let totalUnitPriceTotal = 0;
			let missionCYTotal = 0;
			let sanbenitoCYTotal = 0;
			let brownsvilleCYTotal = 0;
			let missionCogsTotal = 0;
			let sanbenitoCogsTotal = 0;
			let brownsvilleCogsTotal = 0;
			let missionSalesTotal = 0;
			let sanbenitoSalesTotal = 0;
			let brownsvilleSalesTotal = 0;
			let missionGrossTotal = 0;
			let sanbenitoGrossTotal = 0;
			let brownsvilleGrossTotal = 0;

			let missionCount = 0;
			let sanbenitoCount = 0;
			let brownsvilleCount = 0;

			pageData.forEach((item) => {
				totalYardsTotal += item.totalYards;
				totalUnitPriceTotal += item.totalUnitPrice;
				missionCYTotal += item.missionCY || 0;
				sanbenitoCYTotal += item.sanbenitoCY || 0;
				brownsvilleCYTotal += item.brownsvilleCY || 0;
				missionCogsTotal += item.missionCogs || 0;
				sanbenitoCogsTotal += item.sanbenitoCogs || 0;
				brownsvilleCogsTotal += item.brownsvilleCogs || 0;
				missionGrossTotal += item.missionGross > 0 ? item.missionGross : 0;
				sanbenitoGrossTotal +=
					item.sanbenitoGross > 0 ? item.sanbenitoGross : 0;
				brownsvilleGrossTotal +=
					item.brownsvilleGross > 0 ? item.brownsvilleGross : 0;

				if (item.plant === "Mission") {
					missionCount++;
				} else if (item.plant === "San Benito") {
					sanbenitoCount++;
				} else if (item.plant === "Brownsville") {
					brownsvilleCount++;
				}
			});

			let missionCogsTOTAL = 0;
			if (missionCount > 0) {
				missionCogsTOTAL = missionCogsTotal / missionCount;
			}
			let sanbenitoCogsTOTAL = 0;
			if (missionCount > 0) {
				sanbenitoCogsTOTAL = sanbenitoCogsTotal / sanbenitoCount;
			}
			let brownsvilleCogsTOTAL = 0;
			if (brownsvilleCount > 0) {
				brownsvilleCogsTOTAL = brownsvilleCogsTotal / brownsvilleCount;
			}

			missionSalesTotal = missionCYTotal / totalYardsTotal;
			sanbenitoSalesTotal = sanbenitoCYTotal / totalYardsTotal;
			brownsvilleSalesTotal = brownsvilleCYTotal / totalYardsTotal;

			return (
				<>
					<Table.Summary.Row>
						<Table.Summary.Cell colSpan={plantName === "All" ? 2 : 3} />
						<Table.Summary.Cell>
							<Text style={{ fontSize: 14 }} strong>
								{"Total"}
							</Text>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={totalYardsTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell>
							<Statistic
								title=""
								value={totalUnitPriceTotal}
								style={{ fontWeight: "bold" }}
								precision={2}
								valueStyle={{ fontSize: 14 }}
								prefix={"$"}
							/>
						</Table.Summary.Cell>
						<Table.Summary.Cell colSpan={1} />
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionCYTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoCYTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleCYTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
								/>
							</Table.Summary.Cell>
						)}
						<Table.Summary.Cell colSpan={1} />
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionCogsTOTAL}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoCogsTOTAL}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleCogsTOTAL}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionSalesTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoSalesTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleSalesTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Mission") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={missionGrossTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "San Benito") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={sanbenitoGrossTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
						{(plantName === "All" || plantName === "Brownsville") && (
							<Table.Summary.Cell>
								<Statistic
									title=""
									value={brownsvilleGrossTotal}
									style={{ fontWeight: "bold" }}
									precision={2}
									valueStyle={{ fontSize: 14 }}
									prefix={"$"}
								/>
							</Table.Summary.Cell>
						)}
					</Table.Summary.Row>
				</>
			);
		};

		let jobs = row.jobs.map((item, index) => {
			let plant = {};
			let totalCogs = 0;
			switch (item.plant.name) {
				case "Mission":
					plant.missionCY = item.loadYD3 * item.qbPrice || 0;
					totalCogs = getAggregateCogsCost(item.aggregate);
					plant.missionCogs = totalCogs;
					plant.missionSales = item.qbPrice || 0;
					plant.missionGross = plant.missionSales - plant.missionCogs;
					break;
				case "San Benito":
					plant.sanbenitoCY = item.loadYD3 * item.qbPrice || 0;
					totalCogs = getAggregateCogsCost(item.aggregate);
					plant.sanbenitoCogs = totalCogs;
					plant.sanbenitoSales = item.qbPrice || 0;
					plant.sanbenitoGross = plant.sanbenitoSales - plant.sanbenitoCogs;
					break;
				case "Brownsville":
					plant.brownsvilleCY = item.loadYD3 * item.qbPrice || 0;
					totalCogs = getAggregateCogsCost(item.aggregate);
					plant.brownsvilleCogs = totalCogs;
					plant.brownsvilleSales = item.qbPrice || 0;
					plant.brownsvilleGross =
						plant.brownsvilleSales - plant.brownsvilleCogs;
					break;

				default:
					break;
			}

			return {
				...item,
				key: index,
				plant: item.plant.name,
				psi: item.psiId.psi,
				totalYards: item.loadYD3,
				totalUnitPrice: item.loadYD3 * item.unitPrice,
				totalAverage:
					item.loadYD3 === 0
						? 0
						: (item.loadYD3 * item.unitPrice) / item.loadYD3,
				date: dayjs(item.scheduledDate).format("MM/DD/YYYY"),
				client: item.customer.name,
				jobId: item.number,
				qbPrice: item.qbPrice || 0,
				...plant,
			};
		});

		const editableFields = [
			// "missionSales",
			// "sanbenitoSales",
			// "brownsvilleSales",
		];

		const buildEditableColumns = (columns) => {
			return columns.map((column) => {
				if (column.children) {
					return {
						...column,
						children: buildEditableColumns(column.children),
					};
				}

				if (!editableFields.includes(column.dataIndex)) {
					return column;
				}

				return {
					...column,
					editable: true,
					onCell: (record) => ({
						record,
						editable: true,
						dataIndex: column.dataIndex,
						title: column.title,
						handleSave,
					}),
				};
			});
		};

		const mergedColumns = buildEditableColumns(columns2);

		const handleSave = async (editedRow, field) => {
			await updateJob(editedRow._id, editedRow[field]);

			setList((prev) =>
				prev.map((group) => {
					if (group.key !== row.key) return group;

					let cyField = "";

					switch (field) {
						case "missionSales":
							cyField = "missionCY";
							break;

						case "sanbenitoSales":
							cyField = "sanbenitoCY";

							break;

						case "brownsvilleSales":
							cyField = "brownsvilleCY";

							break;

						default:
							return group;
					}

					const updatedJobs = group.jobs.map((job) =>
						job._id === editedRow._id
							? {
									...job,
									qbPrice: editedRow[field],
									[cyField]: editedRow[field] * job.loadYD3,
								}
							: job,
					);

					let missionCY = 0;
					let sanbenitoCY = 0;
					let brownsvilleCY = 0;

					let missionCogsTotal = 0;
					let sanbenitoCogsTotal = 0;
					let brownsvilleCogsTotal = 0;

					let missionCount = 0;
					let sanbenitoCount = 0;
					let brownsvilleCount = 0;

					let missionGrossTotal = 0;
					let sanbenitoGrossTotal = 0;
					let brownsvilleGrossTotal = 0;

					updatedJobs.forEach((job) => {
						const totalCogs = getAggregateCogsCost(job.aggregate);

						switch (job.plant.name) {
							case "Mission":
								missionCY += job.loadYD3 * (job.qbPrice || 0);
								missionCogsTotal += totalCogs;
								missionCount++;
								missionGrossTotal += Math.max(
									(job.qbPrice || 0) - totalCogs,
									0,
								);
								break;

							case "San Benito":
								sanbenitoCY += job.loadYD3 * (job.qbPrice || 0);
								sanbenitoCogsTotal += totalCogs;
								sanbenitoCount++;
								sanbenitoGrossTotal += Math.max(
									(job.qbPrice || 0) - totalCogs,
									0,
								);
								break;

							case "Brownsville":
								brownsvilleCY += job.loadYD3 * (job.qbPrice || 0);
								brownsvilleCogsTotal += totalCogs;
								brownsvilleCount++;
								brownsvilleGrossTotal += Math.max(
									(job.qbPrice || 0) - totalCogs,
									0,
								);
								break;

							default:
								break;
						}
					});

					const missionCogsAvg =
						missionCount > 0 ? missionCogsTotal / missionCount : 0;

					const sanbenitoCogsAvg =
						sanbenitoCount > 0 ? sanbenitoCogsTotal / sanbenitoCount : 0;

					const brownsvilleCogsAvg =
						brownsvilleCount > 0 ? brownsvilleCogsTotal / brownsvilleCount : 0;

					const qbInvoicedAvg = missionCY + sanbenitoCY + brownsvilleCY;

					const cogsAvg =
						missionCogsAvg + sanbenitoCogsAvg + brownsvilleCogsAvg;

					const qbPriceAvg =
						group.totalYards === 0 ? 0 : qbInvoicedAvg / group.totalYards;

					const grossProfitAvg =
						missionGrossTotal + sanbenitoGrossTotal + brownsvilleGrossTotal;

					return {
						...group,
						jobs: updatedJobs,

						missionCY,
						sanbenitoCY,
						brownsvilleCY,

						qbInvoicedAvg,
						cogsAvg,
						qbPriceAvg,
						grossProfitAvg,
					};
				}),
			);

			setListCSV((prev) =>
				prev.map((job) => {
					if (job._id !== editedRow._id) return job;

					let grossField = "";
					let salesField = "";
					let cogsField = "";
					let cyField = "";

					switch (field) {
						case "missionSales":
							salesField = "missionSales";
							grossField = "missionGross";
							cogsField = "missionCogs";
							cyField = "missionCY";
							break;

						case "sanbenitoSales":
							salesField = "sanbenitoSales";
							grossField = "sanbenitoGross";
							cogsField = "sanbenitoCogs";
							cyField = "sanbenitoCY";

							break;

						case "brownsvilleSales":
							salesField = "brownsvilleSales";
							grossField = "brownsvilleGross";
							cogsField = "brownsvilleCogs";
							cyField = "brownsvilleCY";

							break;

						default:
							return job;
					}

					return {
						...job,
						qbPrice: editedRow[field],
						[salesField]: editedRow[field],
						[grossField]:
							editedRow[field] - (job[cogsField] || 0) < 0
								? 0
								: editedRow[field] - (job[cogsField] || 0),
						[cyField]: editedRow[field] * job.loadYD3,
					};
				}),
			);
		};

		return (
			<Table
				columns={mergedColumns}
				components={{
					body: {
						row: EditableRow,
						cell: EditableCell,
					},
				}}
				dataSource={jobs}
				pagination={false}
				summary={summaryChild}
			/>
		);
	};

	useEffect(() => {
		getPlants();
		// getAvgGrossByPlant();
		// getYardsByPlant();
	}, []);

	useEffect(() => {
		getLogisticsList();
	}, [startDate, endDate, plant]);

	const getLogisticsList = async () => {
		setLoading(true);
		setListCSV([]);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/job/get/salesbyplant/${plant}/${"All"}?startDate=${start}&endDate=${end}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				const groupedPsi = data.payload
					.filter((i) => i.psiId !== null && i.psiId !== undefined)
					.reduce((acc, item) => {
						if (!acc[`${item.psiId._id}_${item.psiId.psi}`]) {
							acc[`${item.psiId._id}_${item.psiId.psi}`] = [];
						}
						acc[`${item.psiId._id}_${item.psiId.psi}`].push(item);
						return acc;
					}, {});

				const newRows = Object.entries(groupedPsi).map(([key, values]) => {
					const fistRow = values[0];
					const [psiId, psiName] = key.split("_");

					const totalUnitPrice = values.reduce(
						(accum, r) => accum + r.loadYD3 * r.unitPrice,
						0,
					);

					const totalYards = values.reduce((accum, r) => accum + r.loadYD3, 0);

					let obj = {
						key: psiId,
						index: psiId,
						customer: "All Customers",
						plant: plant === "All" ? "All Plants" : fistRow.plant.name,
						psi: psiName,
						jobs: values,
						totalYards: totalYards,
						totalUnitPrice: totalUnitPrice,
						totalAverage: totalUnitPrice / totalYards,
						franchise: fistRow.franchise || "57Concrete",
					};
					return obj;
				});

				const listRows2 = [];

				const newList = newRows.map((itemRow) => {
					let plant = {
						missionCY: 0,
						sanbenitoCY: 0,
						brownsvilleCY: 0,
						qbInvoicedAvg: 0,
						cogsAvg: 0,
						qbPriceAvg: 0,
						grossProfitAvg: 0,
					};

					let missionCogsTotal = 0;
					let sanbenitoCogsTotal = 0;
					let brownsvilleCogsTotal = 0;

					let missionCount = 0;
					let sanbenitoCount = 0;
					let brownsvilleCount = 0;

					let missionGrossTotal = 0;
					let sanbenitoGrossTotal = 0;
					let brownsvilleGrossTotal = 0;

					itemRow.jobs.map((item, index) => {
						const loadYD3 = item.loadYD3;
						switch (item.plant.name) {
							case "Mission":
								plant.missionCY += loadYD3 * item.qbPrice || 0;
								break;
							case "San Benito":
								plant.sanbenitoCY += loadYD3 * item.qbPrice || 0;
								break;
							case "Brownsville":
								plant.brownsvilleCY += loadYD3 * item.qbPrice || 0;
								break;
							default:
								break;
						}

						const aggregates = item.aggregate || [];

						let plant2 = {};
						let totalCogs = 0;

						switch (item.plant.name) {
							case "Mission":
								plant2.missionCY = item.loadYD3 * item.qbPrice || 0;
								totalCogs = getAggregateCogsCost(item.aggregate);
								plant.cogsAvg = totalCogs;
								plant2.missionCogs = totalCogs;
								plant2.missionSales = item.qbPrice || 0;
								plant2.missionGross =
									plant2.missionSales - plant2.missionCogs < 0
										? 0
										: plant2.missionSales - plant2.missionCogs;

								missionCount++;

								missionCogsTotal += totalCogs;

								missionGrossTotal +=
									plant2.missionSales - plant2.missionCogs < 0
										? 0
										: plant2.missionSales - plant2.missionCogs;
								break;
							case "San Benito":
								plant2.sanbenitoCY = item.loadYD3 * item.qbPrice || 0;
								totalCogs = getAggregateCogsCost(item.aggregate);
								plant2.sanbenitoCogs = totalCogs;
								plant2.sanbenitoSales = item.qbPrice || 0;
								plant2.sanbenitoGross =
									plant2.sanbenitoSales - plant2.sanbenitoCogs < 0
										? 0
										: plant2.sanbenitoSales - plant2.sanbenitoCogs;

								sanbenitoCount++;

								sanbenitoCogsTotal += totalCogs;

								sanbenitoGrossTotal +=
									plant2.sanbenitoSales - plant2.sanbenitoCogs < 0
										? 0
										: plant2.sanbenitoSales - plant2.sanbenitoCogs;
								break;
							case "Brownsville":
								plant2.brownsvilleCY = item.loadYD3 * item.qbPrice || 0;
								totalCogs = getAggregateCogsCost(item.aggregate);
								plant2.brownsvilleCogs = totalCogs;
								plant2.brownsvilleSales = item.qbPrice || 0;
								plant2.brownsvilleGross =
									plant2.brownsvilleSales - plant2.brownsvilleCogs < 0
										? 0
										: plant2.brownsvilleSales - plant2.brownsvilleCogs;

								brownsvilleCount++;

								brownsvilleCogsTotal += totalCogs;

								brownsvilleGrossTotal +=
									plant2.brownsvilleSales - plant2.brownsvilleCogs < 0
										? 0
										: plant2.brownsvilleSales - plant2.brownsvilleCogs;
								break;

							default:
								break;
						}

						listRows2.push({
							...item,
							key: item.psiId._id,
							plant: item.plant.name,
							psi: item.psiId.psi,
							totalYards: item.loadYD3,
							totalUnitPrice: item.loadYD3 * item.unitPrice || 0,
							totalAverage:
								item.loadYD3 === 0
									? 0
									: (item.loadYD3 * item.unitPrice || 0) / item.loadYD3,
							client: item.customer.name,
							date: dayjs(item.scheduledDate).format("MM/DD/YYYY"),
							jobId: item.number.toString(),
							qbPrice: item.qbPrice || 0,
							...plant2,
						});
					});

					const missionCogsAvg =
						missionCount > 0 ? missionCogsTotal / missionCount : 0;
					const sanbenitoCogsAvg =
						sanbenitoCount > 0 ? sanbenitoCogsTotal / sanbenitoCount : 0;
					const brownsvilleCogsAvg =
						brownsvilleCount > 0 ? brownsvilleCogsTotal / brownsvilleCount : 0;

					plant.qbInvoicedAvg =
						plant.missionCY + plant.sanbenitoCY + plant.brownsvilleCY;
					plant.cogsAvg =
						missionCogsAvg + sanbenitoCogsAvg + brownsvilleCogsAvg;
					plant.qbPriceAvg =
						itemRow.totalYards === 0
							? 0
							: plant.qbInvoicedAvg / itemRow.totalYards;
					plant.grossProfitAvg =
						missionGrossTotal + sanbenitoGrossTotal + brownsvilleGrossTotal;

					return {
						...itemRow,
						...plant,
					};
				});

				newList.sort((a, b) =>
					String(a.psi).localeCompare(String(b.psi), undefined, {
						numeric: true,
						sensitivity: "base",
					}),
				);

				listRows2.sort((a, b) =>
					String(a.psi).localeCompare(String(b.psi), undefined, {
						numeric: true,
						sensitivity: "base",
					}),
				);

				setList(newList);
				setListCSV(listRows2);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get jobs");
			console.error(err.message);
			return null;
		}
	};

	const updateJob = async (id, qbPrice) => {
		try {
			setLoadingTable(true);

			const url = api + `/job/${id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			await axios.patch(url, { qbPrice: qbPrice });

			openNotification("success", "Success", "QB Price Updated");

			setLoadingTable(false);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to update jobs");
			console.error(err.message);
			return null;
		}
	};

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [
				{
					value: "All",
					label: "All",
				},
			];
			data.payload.map((item) => {
				list.push({
					value: item._id,
					label: item.name,
				});
			});
			setOptionsPlant(list);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getAvgGrossByPlant = async () => {
		const url = api + `/avggross/get/bymonth`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			setLoadingTable3(true);
			const { data } = await axios.get(url);

			const rows = data.payload.map((item) => {
				const months = item.months.reduce((acc, month) => {
					acc[month.month] = month.avgGross;
					return acc;
				}, {});

				return {
					plant: item.plant,
					total: item.avg,
					Jan: months.Jan ?? 0,
					Feb: months.Feb ?? 0,
					Mar: months.Mar ?? 0,
					Apr: months.Apr ?? 0,
					May: months.May ?? 0,
					Jun: months.Jun ?? 0,
					Jul: months.Jul ?? 0,
					Aug: months.Aug ?? 0,
					Sep: months.Sep ?? 0,
					Oct: months.Oct ?? 0,
					Nov: months.Nov ?? 0,
					Dec: months.Dec ?? 0,
				};
			});

			setDataProfit(rows);
			setLoadingTable3(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};
	const getYardsByPlant = async () => {
		const url = api + `/avggross/get/bymonth/job`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			setLoadingTable4(true);
			const { data } = await axios.get(url);

			const rows = data.payload.map((item) => {
				const months = item.months.reduce((acc, month) => {
					acc[month.month] = month.yards;
					return acc;
				}, {});

				return {
					plant: item.plant,
					total: item.total,
					Jan: months.Jan ?? 0,
					Feb: months.Feb ?? 0,
					Mar: months.Mar ?? 0,
					Apr: months.Apr ?? 0,
					May: months.May ?? 0,
					Jun: months.Jun ?? 0,
					Jul: months.Jul ?? 0,
					Aug: months.Aug ?? 0,
					Sep: months.Sep ?? 0,
					Oct: months.Oct ?? 0,
					Nov: months.Nov ?? 0,
					Dec: months.Dec ?? 0,
				};
			});

			setDataYards(rows);
			setLoadingTable4(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					title={() => "Franchise 57Concrete"}
					columns={columns}
					dataSource={list.filter((i) => i.franchise === "57Concrete")}
					expandable={{
						expandedRowRender,
					}}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [50, 100],
						defaultPageSize: 50,
						showSizeChanger: true,
					}}
					scroll={{
						x: "max-content",
					}}
					style={{
						minWidth: "100%",
					}}
					onRow={(record) => ({
						style: {
							background: "#7686bbff",
						},
					})}
					summary={summaryParent}
					loading={loadingTable}
				/>
			</Flex>
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const onChangePlantPicker = (value) => {
		setPlant(value.value);
		setPlantName(value.label);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const RenderDates = () => {
		return (
			<Flex justify="space-between" align="flex-start">
				<Flex vertical gap={16}>
					<Flex gap={16}>
						<div>
							<Text>Dates</Text>
							<br />
							<RangePicker
								defaultValue={[
									dayjs(startDate, "MM/DD/YYYY"),
									dayjs(endDate, "MM/DD/YYYY"),
								]}
								onChange={onRangeChange}
								format="MM/DD/YYYY"
								size="large"
								disabled={loading}
								allowClear={false}
							/>
						</div>

						<div>
							<Text>Plant</Text>
							<br />
							<Select
								showSearch
								placeholder="Select plant"
								optionFilterProp="children"
								size="large"
								onChange={onChangePlantPicker}
								filterOption={filterOption}
								options={optionsPlant}
								disabled={loading}
								value={plant}
								style={{ width: 250 }}
								allowClear={false}
								labelInValue
							/>
						</div>
					</Flex>

					<Button
						type="primary"
						onClick={handleExportXlsx}
						loading={loading}
						disabled={list.length === 0}
					>
						Download Report
					</Button>
				</Flex>

				{/* <Flex vertical gap={12}>
					<Table
						columns={columns4}
						dataSource={dataYards}
						scroll={{ x: "max-content" }}
						summary={summaryParent4}
						loading={loadingTable4}
					/>

					<Table
						columns={columns3}
						dataSource={dataProfit}
						scroll={{ x: "max-content" }}
						summary={summaryParent3}
						loading={loadingTable3}
					/>
				</Flex> */}
			</Flex>
		);
	};

	function getFlattenedHeaders(columns, parent = "") {
		return columns.flatMap((col) => {
			const title = col.title;
			if (col.children) {
				return getFlattenedHeaders(col.children, title);
			}
			return title;
		});
	}

	function getFlattenedKeys(columns, parent = "") {
		return columns.flatMap((col) => {
			if (col.children) {
				return getFlattenedKeys(col.children, parent); // skip grouping name
			}
			return col.dataIndex || col.key || ""; // prefer dataIndex, fallback to key
		});
	}

	const isNumber = (v) => typeof v === "number" && Number.isFinite(v);

	const buildBody = (list, franchise) => {
		let data = [];

		if (list.length === 0) {
			return data;
		}

		const headers = getFlattenedHeaders(columns2);
		const keys = getFlattenedKeys(columns2);

		//MAIN DATA
		data.push(["PROFITABILITY REPORT DETAIL"]);
		data.push(["PROFITABILITY REPORT SUMMARY"]);
		data.push([]);
		data.push(["Lower", "Upper"]);
		const start = `${
			startDate.month() + 1
		}/${startDate.date()}/${startDate.year()}`;
		const end = `${endDate.month() + 1}/${endDate.date()}/${endDate.year()}`;
		data.push([start, end]);
		data.push([]);
		data.push([
			"Plant",
			plant === "All" ? "All Plants" : list[0].plant,
			"",
			"Franchise",
			franchise,
		]);
		data.push([]);

		//MAIN HEADER
		list.map((itemList) => {
			const topHeader = [
				" ",
				" ",
				plantName !== "All" && " ",
				" ",
				" ",
				" ",
				" ",
				(plantName === "All" || plantName === "Mission") && "QB INVOICED",
				(plantName === "All" || plantName === "San Benito") && "QB INVOICED",
				(plantName === "All" || plantName === "Brownsville") && "QB INVOICED",
				" ",
				(plantName === "All" || plantName === "Mission") && "COGS",
				(plantName === "All" || plantName === "San Benito") && "COGS",
				(plantName === "All" || plantName === "Brownsville") && "COGS",
				(plantName === "All" || plantName === "Mission") && "QB PRICE",
				(plantName === "All" || plantName === "San Benito") && "QB PRICE",
				(plantName === "All" || plantName === "Brownsville") && "QB PRICE",
				(plantName === "All" || plantName === "Mission") && "GROSS PROFIT",
				(plantName === "All" || plantName === "San Benito") && "GROSS PROFIT",
				(plantName === "All" || plantName === "Brownsville") && "GROSS PROFIT",
			].filter(Boolean);
			data.push(topHeader);

			//SUB HEADER
			data.push(headers);

			//EACH LINE
			const childrenList = listCSV.filter((l) => l.key === itemList.key);
			childrenList.map((children) => {
				let newRow = [];
				keys.forEach((key) => {
					newRow.push(
						isNumber(children[key])
							? children[key].toFixed(2)
							: (children[key] ?? ""),
					);
				});

				data.push(newRow);
			});
			//SUBTOTAL
			let totalRow = plant !== "All" ? ["", "", "Subtotal"] : ["", "Subtotal"];
			keys.slice(plant !== "All" ? 3 : 2).forEach((key) => {
				if (
					key === "client" ||
					key === "missionCogs" ||
					key === "sanbenitoCogs" ||
					key === "brownsvilleCogs" ||
					key === "missionSales" ||
					key === "sanbenitoSales" ||
					key === "brownsvilleSales" ||
					key === "missionGross" ||
					key === "sanbenitoGross" ||
					key === "brownsvilleGross"
				) {
					totalRow.push("");
				} else {
					totalRow.push(
						isNumber(itemList[key])
							? itemList[key].toFixed(2)
							: (itemList[key] ?? ""),
					);
				}
			});

			//DATA BELOW SUBTOTAL
			let totalRow2 = plant !== "All" ? ["", "", ""] : ["", ""];
			keys.slice(plant !== "All" ? 3 : 2).forEach((key) => {
				if (key === "missionSalesTotal" || key === "missionGrossTotal") {
					totalRow2.push(
						(itemList[key] / itemList["missionCY"] || 0).toFixed(2),
					);
				} else if (
					key === "sanbenitoSalesTotal" ||
					key === "sanbenitoGrossTotal"
				) {
					totalRow2.push(
						(itemList[key] / itemList["sanbenitoCY"] || 0).toFixed(2),
					);
				} else if (
					key === "brownsvilleSalesTotal" ||
					key === "brownsvilleGrossTotal"
				) {
					totalRow2.push(
						(itemList[key] / itemList["brownsvilleCY"] || 0).toFixed(2),
					);
				} else {
					totalRow2.push("");
				}
			});
			data.push(totalRow2);
			data.push([]);
		});

		//TOTAL
		let totalRow3 = plant !== "All" ? ["", "", "", "Total"] : ["", "", "Total"];
		keys.slice(plant !== "All" ? 4 : 3).forEach((key) => {
			if (
				key === "jobId" ||
				key === "client" ||
				key === "totalAverage" ||
				key === "missionCogs" ||
				key === "sanbenitoCogs" ||
				key === "brownsvilleCogs" ||
				key === "missionSales" ||
				key === "sanbenitoSales" ||
				key === "brownsvilleSales" ||
				key === "missionGross" ||
				key === "sanbenitoGross" ||
				key === "brownsvilleGross"
			) {
				totalRow3.push("");
			} else {
				totalRow3.push(
					list
						.reduce((acc, item) => {
							return acc + item[key];
						}, 0)
						.toFixed(2),
				);
			}
		});

		data.push(totalRow3);
		data.push([]);
		return data;
	};

	const handleExportXlsx = () => {
		const data = buildBody(
			list.filter((i) => i.franchise === "57Concrete"),
			"57Concrete",
		);

		const ws = XLSX.utils.aoa_to_sheet(data);

		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(
			wb,
			ws,
			plant === "All" ? "All Plants" : list[0].plant,
		);

		// Step 4: Export file
		XLSX.writeFile(wb, `57 Profitability Report.xlsx`);
	};

	// const RenderDownloadReport = () => {
	// 	return (
	// 		<div>
	// 			<Row gutter={16}>
	// 				<Col span={24}>
	// 					<Button
	// 						type="primary"
	// 						style={{ width: "100%" }}
	// 						onClick={handleExportXlsx}
	// 						loading={loading}
	// 						disabled={list.length === 0}
	// 					>
	// 						Download Report
	// 					</Button>
	// 				</Col>
	// 			</Row>
	// 		</div>
	// 	);
	// };

	return (
		<Layout title="Profitability Report" description="Report" type="large">
			<Flex vertical gap={"large"}>
				<RenderDates />
				{/* <RenderDownloadReport /> */}
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
			{contextHolder}
		</Layout>
	);
};

export default ProfitabilityReport;
